import React from 'react';

const InitialPage: React.FC = () => {
  return <>Visualization Module</>;
};

export default InitialPage;
